import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"
import { TimePeriod } from "./metal-price";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const getPeriodText = (period: TimePeriod): string => {
  const periodMap: Record<TimePeriod, string> = {
    week: 'settimanale',
    month: 'mensile',
    year: 'annuale',
    all: 'complessivo'
  };
  return periodMap[period] || 'selezionato';
};

export function formatCurrency(amount: number | null | undefined): string {
  if (amount === null || amount === undefined || isNaN(amount)) {
    return 'N/A';
  }
  return amount.toLocaleString('it-IT', {
    style: 'currency',
    currency: 'EUR'
  });
}
